module.exports = __webpack_public_path__ + "img/icn_scarpa_edit_1.7fe924c7.png";